type AddressInput = {
  place?: string;
  street?: string;
  buildingNumber?: string | number;
  localNumber?: string | number;
  zipCode?: string;
};

export function formatAddress({
  place,
  street,
  buildingNumber,
  localNumber,
  zipCode,
}: AddressInput): string {
  const parts: string[] = [];

  // Building/local number
  const numberPart =
    buildingNumber !== undefined && buildingNumber !== null
      ? `${buildingNumber}${localNumber ? `/${localNumber}` : ""}`
      : "";

  // Street OR place + number (when street is missing)
  if (street) {
    let streetPart = `${street}`;
    if (numberPart) {
      streetPart += ` ${numberPart}`;
    }
    parts.push(streetPart);
  } else if (place && numberPart) {
    parts.push(`${place} ${numberPart}`);
  }

  // ZIP + place (do not duplicate place)
  const cityPart = [zipCode, place].filter(Boolean).join(" ");

  if (cityPart) {
    parts.push(cityPart);
  }

  return parts.join(", ");
}
